import type { EntityCtx } from '@cli-types/next-adapter/generators.js'
import { buildAuthorshipAliasBlock } from '@next-adapter/generators/actions/action-helpers/build-authorship-alias-block.js'
import { renderGenGetBySlugContentServerActionTemplate } from '@next-adapter/templates/renderers/generators/actions/entity-file-contents/gen-get-by-slug-content.js'

export function genGetBySlugContent(ctx: EntityCtx): string | null {
  if (!ctx.hasSlug) return null
  const dbImports = [ctx.tableVar, 'user', ...ctx.relTableImports].sort()
  const drizzle: string[] = ['eq']
  const sortedDrizzle = [...new Set(drizzle)].sort()

  const bySlugHelperImports: string[] = ['formatActionDate']
  if (ctx.hasSelectFields) bySlugHelperImports.push(`resolve${ctx.Singular}SelectFields`)
  if (ctx.hasListRels) bySlugHelperImports.push(`populate${ctx.Singular}ListRelationships`)
  if (ctx.hasMediaFields) bySlugHelperImports.push(`resolve${ctx.Singular}MediaFields`)
  const populateImport =
    bySlugHelperImports.length > 0
      ? `\nimport { ${bySlugHelperImports.join(', ')} } from './helpers'`
      : ''

  return renderGenGetBySlugContentServerActionTemplate({
    join: dbImports.join(', '),
    joinText: sortedDrizzle.join(', '),
    ctxCacheReadImport: ctx.cacheReadImport,
    ctxCamelPlural: ctx.camelPlural,
    ctxSingular: ctx.Singular,
    populateImport: populateImport,
    authorshipAliasBlock: buildAuthorshipAliasBlock(),
    ctxCacheLifeLine: ctx.cacheLifeLine,
    ctxSelectClause: ctx.selectClause,
    ctxTableVar: ctx.tableVar,
    ctxSingleRowReturn: ctx.singleRowReturn,
    ctxSingularText: ctx.singular
  })
}
